/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import { _ as _objectWithoutProperties } from '../../_chunks/dep-92728dc5.js';
import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import React, { useRef, useMemo, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { i as isFunction_1 } from '../../_chunks/dep-f10515e8.js';
import { g as get_1 } from '../../_chunks/dep-337b4140.js';
import useControlled from '../../hooks/useControlled.js';
import { useLocaleReceiver } from '../../locale/LocalReceiver.js';
import useConfig from '../../hooks/useConfig.js';
import forwardRefWithStatics from '../../_util/forwardRefWithStatics.js';
import { getSelectValueArr, getSelectedOptions } from '../util/helper.js';
import noop from '../../_util/noop.js';
import FakeArrow from '../../common/FakeArrow.js';
import { Loading } from '../../loading/index.js';
import { SelectInput } from '../../select-input/index.js';
import Option from './Option.js';
import OptionGroup from './OptionGroup.js';
import PopupContent from './PopupContent.js';
import { Tag } from '../../tag/index.js';
import { selectDefaultProps } from '../defaultProps.js';
import UseOptions from '../hooks/useOptions.js';
import composeRefs from '../../_util/composeRefs.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-ca64038e.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-33ffecad.js';
import '../../_chunks/dep-f721d103.js';
import '../../_chunks/dep-4559db64.js';
import '../../_chunks/dep-c00532d4.js';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../config-provider/ConfigContext.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import 'hoist-non-react-statics';
import '../../_chunks/dep-fd3498b6.js';
import '../../loading/Loading.js';
import '../../_util/dom.js';
import 'raf';
import '../../_chunks/dep-6c5254c6.js';
import '../../_util/easing.js';
import '../../common/Portal.js';
import 'react-dom';
import '../../loading/gradient.js';
import '../../hooks/useDomRefCallback.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '../../_chunks/dep-ec16db36.js';
import '../../_chunks/dep-036ad2cc.js';
import '../../_chunks/dep-0e15088f.js';
import '../../loading/defaultProps.js';
import '../../loading/plugin.js';
import '../../_util/react-render.js';
import '../../_chunks/dep-e0370ebe.js';
import '../../loading/style/css.js';
import '../../loading/type.js';
import '../../select-input/SelectInput.js';
import '../../popup/index.js';
import '../../popup/Popup.js';
import 'react-transition-group';
import 'react-popper';
import '../../_util/useAnimation.js';
import '../../hooks/usePrevious.js';
import '../../popup/hooks/useTrigger.js';
import 'react-is';
import '../../popup/utils/ref.js';
import '../../popup/utils/transition.js';
import '../../_util/useMutationObserver.js';
import '../../_chunks/dep-01ce608f.js';
import '../../_chunks/dep-77a54538.js';
import '../../_util/useWindowSize.js';
import '../../popup/defaultProps.js';
import '../../popup/style/css.js';
import '../../popup/type.js';
import '../../select-input/useSingle.js';
import '../../_chunks/dep-4f1e1217.js';
import '../../_chunks/dep-29cb89ad.js';
import '../../_chunks/dep-e73d1b75.js';
import '../../_chunks/dep-c8399d32.js';
import '../../input/index.js';
import '../../input/Input.js';
import 'tdesign-icons-react';
import '../../_util/useLayoutEffect.js';
import '../../hooks/useGlobalIcon.js';
import '../../input/InputGroup.js';
import '../../input/defaultProps.js';
import '../../_util/parseTNode.js';
import '../../input/useLengthLimit.js';
import '../../_common/js/log/index.js';
import '../../_common/js/log/log.js';
import '../../input/style/css.js';
import '../../input/type.js';
import '../../select-input/useMultiple.js';
import '../../tag-input/index.js';
import '../../tag-input/TagInput.js';
import '../../_util/useDragSorter.js';
import '../../tag-input/useTagScroll.js';
import '../../tag-input/useTagList.js';
import '../../tag-input/useHover.js';
import '../../tag-input/defaultProps.js';
import '../../tag/Tag.js';
import '../../tag/CheckTag.js';
import '../../tag/defaultProps.js';
import '../../tag/style/css.js';
import '../../tag/type.js';
import '../../tag-input/style/css.js';
import '../../tag-input/type.js';
import '../../select-input/useOverlayInnerStyle.js';
import '../../select-input/defaultProps.js';
import '../../select-input/style/css.js';
import '../../select-input/type.js';
import '../../_util/useRipple.js';
import '../../_util/setStyle.js';
import '../hooks/usePanelVirtualScroll.js';
import '../../hooks/useVirtualScroll.js';
import '../../hooks/useResizeObserver.js';

var _excluded = ["overlayClassName"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Select = forwardRefWithStatics(function (props, ref) {
  var _useLocaleReceiver = useLocaleReceiver("select"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 2),
    local = _useLocaleReceiver2[0],
    t = _useLocaleReceiver2[1];
  var emptyText = t(local.loadingText);
  var readonly = props.readonly,
    borderless = props.borderless,
    autoWidth = props.autoWidth,
    creatable = props.creatable,
    filter = props.filter,
    _props$loadingText = props.loadingText,
    loadingText = _props$loadingText === void 0 ? emptyText : _props$loadingText,
    max = props.max,
    popupProps = props.popupProps,
    reserveKeyword = props.reserveKeyword,
    className = props.className,
    style = props.style,
    disabled = props.disabled,
    size = props.size,
    multiple = props.multiple,
    placeholder = props.placeholder,
    clearable = props.clearable,
    prefixIcon = props.prefixIcon,
    options = props.options,
    filterable = props.filterable,
    loading = props.loading,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    _props$onClear = props.onClear,
    onClear = _props$onClear === void 0 ? noop : _props$onClear,
    onCreate = props.onCreate,
    onRemove = props.onRemove,
    onSearch = props.onSearch,
    empty = props.empty,
    valueType = props.valueType,
    keys = props.keys,
    children = props.children,
    collapsedItems = props.collapsedItems,
    minCollapsedNum = props.minCollapsedNum,
    valueDisplay = props.valueDisplay,
    onEnter = props.onEnter,
    showArrow = props.showArrow,
    inputProps = props.inputProps,
    panelBottomContent = props.panelBottomContent,
    panelTopContent = props.panelTopContent,
    selectInputProps = props.selectInputProps,
    tagInputProps = props.tagInputProps,
    tagProps = props.tagProps,
    scroll = props.scroll;
  var _useControlled = useControlled(props, "value", props.onChange),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    onChange = _useControlled2[1];
  var selectInputRef = useRef(null);
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _ref = popupProps || {},
    overlayClassName = _ref.overlayClassName,
    restPopupProps = _objectWithoutProperties(_ref, _excluded);
  var name = "".concat(classPrefix, "-select");
  var _useControlled3 = useControlled(props, "popupVisible", props.onPopupVisibleChange),
    _useControlled4 = _slicedToArray(_useControlled3, 2),
    showPopup = _useControlled4[0],
    setShowPopup = _useControlled4[1];
  var _useControlled5 = useControlled(props, "inputValue", props.onInputChange),
    _useControlled6 = _slicedToArray(_useControlled5, 2),
    inputValue = _useControlled6[0],
    onInputChange = _useControlled6[1];
  var _useOptions = UseOptions(keys, options, children, valueType, value),
    currentOptions = _useOptions.currentOptions,
    setCurrentOptions = _useOptions.setCurrentOptions,
    tmpPropOptions = _useOptions.tmpPropOptions,
    valueToOption = _useOptions.valueToOption,
    selectedOptions = _useOptions.selectedOptions;
  var selectedLabel = useMemo(function () {
    if (multiple) {
      return selectedOptions.map(function (selectedOption) {
        return get_1(selectedOption || {}, (keys === null || keys === void 0 ? void 0 : keys.label) || "label") || "";
      });
    }
    return get_1(selectedOptions[0] || {}, (keys === null || keys === void 0 ? void 0 : keys.label) || "label") || void 0;
  }, [selectedOptions, keys, multiple]);
  var handleShowPopup = function handleShowPopup(visible, ctx) {
    if (disabled) return;
    setShowPopup(visible, ctx);
    visible && inputValue && onInputChange("");
  };
  var onTagChange = function onTagChange(_currentTags, context) {
    var trigger = context.trigger,
      index = context.index,
      item = context.item,
      e = context.e;
    if (trigger === "backspace") {
      e.stopPropagation();
      var closest = -1;
      var len = index;
      while (len >= 0) {
        var _selectedOptions$len;
        if (!((_selectedOptions$len = selectedOptions[len]) !== null && _selectedOptions$len !== void 0 && _selectedOptions$len.disabled)) {
          closest = len;
          break;
        }
        len -= 1;
      }
      if (closest < 0) {
        return;
      }
      var values = getSelectValueArr(value, value[closest], true, valueType, keys);
      var currentSelectedOptions = getSelectedOptions(values, multiple, valueType, keys, tmpPropOptions);
      onChange(values, {
        e: e,
        trigger: trigger,
        selectedOptions: currentSelectedOptions
      });
      return;
    }
    if (trigger === "clear") {
      e.stopPropagation();
      onChange([], {
        e: e,
        trigger: trigger,
        selectedOptions: []
      });
      return;
    }
    if (trigger === "tag-remove") {
      e.stopPropagation();
      var _values = getSelectValueArr(value, value[index], true, valueType, keys);
      var _currentSelectedOptions = getSelectedOptions(_values, multiple, valueType, keys, tmpPropOptions);
      onChange(_values, {
        e: e,
        trigger: trigger,
        selectedOptions: _currentSelectedOptions
      });
      if (isFunction_1(onRemove)) {
        onRemove({
          value: value[index],
          data: {
            label: item,
            value: value[index]
          },
          e: e
        });
      }
    }
  };
  var onCheckAllChange = function onCheckAllChange(checkAll, e) {
    var _props$value;
    if (!props.multiple) return;
    var selectableOptions = currentOptions.filter(function (option) {
      return !option.checkAll && !option.disabled;
    }).map(function (option) {
      return option.value;
    });
    var checkAllValue = !checkAll && selectableOptions.length !== ((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.length) ? selectableOptions : [];
    onChange === null || onChange === void 0 ? void 0 : onChange(checkAllValue, {
      e: e,
      trigger: checkAll ? "check" : "uncheck",
      selectedOptions: checkAllValue
    });
  };
  var handleChange = function handleChange(value2, context) {
    if (multiple) {
      !reserveKeyword && inputValue && onInputChange("", {
        trigger: "clear"
      });
    }
    if (creatable && isFunction_1(onCreate)) {
      if (options.filter(function (option) {
        return option.value === value2;
      }).length === 0) {
        onCreate(value2);
      }
    }
    var currentSelectedOptions = getSelectedOptions(value2, multiple, valueType, keys, tmpPropOptions);
    onChange === null || onChange === void 0 ? void 0 : onChange(value2, _objectSpread(_objectSpread({}, context), {}, {
      selectedOptions: currentSelectedOptions
    }));
  };
  var handleFilter = function handleFilter(value2) {
    var filteredOptions = [];
    if (!value2) {
      setCurrentOptions(tmpPropOptions);
      return;
    }
    if (filter && isFunction_1(filter)) {
      if (Array.isArray(tmpPropOptions)) {
        filteredOptions = tmpPropOptions.filter(function (option) {
          return filter(value2, option);
        });
      } else if (Array.isArray(Object.values(valueToOption))) {
        filteredOptions = Object.values(valueToOption).filter(function (option) {
          return filter(value2, option);
        });
      }
    } else if (Array.isArray(tmpPropOptions)) {
      var upperValue = value2.toUpperCase();
      filteredOptions = tmpPropOptions.filter(function (option) {
        return ((option === null || option === void 0 ? void 0 : option.label) || "").toUpperCase().includes(upperValue);
      });
    }
    if (creatable) {
      filteredOptions = filteredOptions.concat([{
        label: value2,
        value: value2
      }]);
    }
    setCurrentOptions(filteredOptions);
  };
  var handleInputChange = function handleInputChange(value2, context) {
    if (context.trigger !== "clear") onInputChange(value2);
    if (value2 === void 0) return;
    if (isFunction_1(onSearch)) {
      onSearch(value2, {
        e: context.e
      });
      return;
    }
  };
  var onClearValue = function onClearValue(context) {
    context.e.stopPropagation();
    if (Array.isArray(value)) {
      onChange([], _objectSpread(_objectSpread({}, context), {}, {
        selectedOptions: []
      }));
    } else {
      onChange(null, _objectSpread(_objectSpread({}, context), {}, {
        selectedOptions: []
      }));
    }
    onClear(context);
  };
  useEffect(function () {
    if (typeof inputValue !== "undefined") {
      handleFilter(String(inputValue));
    }
  }, [inputValue]);
  var renderSuffixIcon = function renderSuffixIcon() {
    if (props.suffixIcon) return props.suffixIcon;
    if (loading) {
      return /* @__PURE__ */React.createElement(Loading, {
        className: classNames("".concat(name, "__right-icon"), "".concat(name, "__active-icon")),
        loading: true,
        size: "small"
      });
    }
    return showArrow && /* @__PURE__ */React.createElement(FakeArrow, {
      className: "".concat(name, "__right-icon"),
      isActive: showPopup,
      disabled: disabled
    });
  };
  var getPopupInstance = useCallback(function () {
    var _selectInputRef$curre;
    return (_selectInputRef$curre = selectInputRef.current) === null || _selectInputRef$curre === void 0 ? void 0 : _selectInputRef$curre.getPopupContentElement();
  }, []);
  var renderContent = function renderContent() {
    var popupContentProps = {
      onChange: handleChange,
      value: value,
      className: className,
      size: size,
      multiple: multiple,
      showPopup: showPopup,
      setShowPopup: function setShowPopup(show) {
        return handleShowPopup(show, {});
      },
      options: currentOptions,
      empty: empty,
      max: max,
      loadingText: loadingText,
      loading: loading,
      valueType: valueType,
      keys: keys,
      panelBottomContent: panelBottomContent,
      panelTopContent: panelTopContent,
      onCheckAllChange: onCheckAllChange,
      getPopupInstance: getPopupInstance,
      scroll: scroll
    };
    return /* @__PURE__ */React.createElement(PopupContent, _objectSpread({}, popupContentProps), children);
  };
  var renderValueDisplay = function renderValueDisplay() {
    if (!valueDisplay) {
      if (!multiple) {
        if (typeof selectedLabel !== "string") {
          return selectedLabel;
        }
        return "";
      }
      return function (_ref2) {
        var val = _ref2.value;
        return val.slice(0, minCollapsedNum ? minCollapsedNum : val.length).map(function (v, key) {
          var filterOption = options === null || options === void 0 ? void 0 : options.find(function (option) {
            return option.label === v;
          });
          return /* @__PURE__ */React.createElement(Tag, _objectSpread(_objectSpread({
            key: key,
            closable: !(filterOption !== null && filterOption !== void 0 && filterOption.disabled) && !disabled && !readonly
          }, tagProps), {}, {
            onClose: function onClose(_ref3) {
              var _tagProps$onClose;
              var e = _ref3.e;
              e.stopPropagation();
              var values = getSelectValueArr(value, value[key], true, valueType, keys);
              var selectedOptions2 = getSelectedOptions(values, multiple, valueType, keys, tmpPropOptions);
              onChange(values, {
                e: e,
                selectedOptions: selectedOptions2,
                trigger: "uncheck"
              });
              tagProps === null || tagProps === void 0 ? void 0 : (_tagProps$onClose = tagProps.onClose) === null || _tagProps$onClose === void 0 ? void 0 : _tagProps$onClose.call(tagProps, {
                e: e
              });
            }
          }), v);
        });
      };
    }
    if (typeof valueDisplay === "string") {
      return valueDisplay;
    }
    if (multiple) {
      return function (_ref4) {
        var onClose = _ref4.onClose;
        return valueDisplay({
          value: selectedLabel,
          onClose: onClose
        });
      };
    }
    return valueDisplay({
      value: selectedLabel,
      onClose: noop
    });
  };
  var renderCollapsedItems = useMemo(function () {
    return collapsedItems ? function () {
      return collapsedItems({
        value: selectedLabel,
        collapsedSelectedItems: selectedLabel.slice(minCollapsedNum, selectedLabel.length),
        count: selectedLabel.length - minCollapsedNum
      });
    } : null;
  }, [selectedLabel, collapsedItems, minCollapsedNum]);
  var updateScrollTop = function updateScrollTop(content) {
    if (!content) return;
    var firstSelectedNode = content.querySelector(".".concat(classPrefix, "-is-selected"));
    if (firstSelectedNode) {
      var _getComputedStyle = getComputedStyle(firstSelectedNode),
        paddingBottom = _getComputedStyle.paddingBottom;
      var _getComputedStyle2 = getComputedStyle(content),
        marginBottom = _getComputedStyle2.marginBottom;
      var elementBottomHeight = parseInt(paddingBottom, 10) + parseInt(marginBottom, 10);
      var updateValue = firstSelectedNode.offsetTop - content.offsetTop - (content.clientHeight - firstSelectedNode.clientHeight) + elementBottomHeight;
      content.scrollTop = updateValue;
    }
  };
  var onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave;
  var handleEnter = function handleEnter(_, context) {
    onEnter === null || onEnter === void 0 ? void 0 : onEnter(_objectSpread(_objectSpread({}, context), {}, {
      value: value
    }));
  };
  return /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(name, "__wrap"), className),
    style: style,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /* @__PURE__ */React.createElement(SelectInput, _objectSpread({
    autoWidth: !(style !== null && style !== void 0 && style.width) && autoWidth,
    ref: composeRefs(ref, selectInputRef),
    className: name,
    readonly: readonly,
    autofocus: props.autofocus,
    allowInput: (filterable !== null && filterable !== void 0 ? filterable : local.filterable) || isFunction_1(filter),
    multiple: multiple,
    value: selectedLabel,
    valueDisplay: renderValueDisplay(),
    clearable: clearable,
    disabled: disabled,
    status: props.status,
    tips: props.tips,
    borderless: borderless,
    label: prefixIcon,
    suffix: props.suffix,
    suffixIcon: renderSuffixIcon(),
    panel: renderContent(),
    placeholder: !multiple && showPopup && selectedLabel ? selectedLabel : placeholder || t(local.placeholder),
    inputValue: inputValue,
    tagInputProps: _objectSpread({}, tagInputProps),
    tagProps: tagProps,
    inputProps: _objectSpread({
      size: size
    }, inputProps),
    minCollapsedNum: minCollapsedNum,
    collapsedItems: renderCollapsedItems,
    updateScrollTop: updateScrollTop,
    popupProps: _objectSpread({
      overlayClassName: ["".concat(name, "__dropdown"), overlayClassName]
    }, restPopupProps),
    popupVisible: showPopup,
    onPopupVisibleChange: handleShowPopup,
    onTagChange: onTagChange,
    onInputChange: handleInputChange,
    onFocus: onFocus,
    onEnter: handleEnter,
    onBlur: onBlur,
    onClear: function onClear(context) {
      onClearValue(context);
    }
  }, selectInputProps)));
}, {
  Option: Option,
  OptionGroup: OptionGroup
});
Select.displayName = "Select";
Select.defaultProps = selectDefaultProps;

export { Select as default };
//# sourceMappingURL=Select.js.map
